/** Foundation · Timesheet — preferenza aziendale di apertura di "Compila Orari". */
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const TIMESHEET_PREFILL_OPTIONS = [
  { value: "empty", label: "Campi vuoti (foglio presenze cartaceo)" },
  { value: "profile", label: "Precompilati dagli orari previsti del profilo" },
];

export function TimesheetPrefillSelect({ value, onChange, disabled, "data-testid": testid = "company-form-timesheet-prefill" }) {
  return (
    <div>
      <Label>Apertura &quot;Compila Orari&quot;</Label>
      <Select value={value === "profile" ? "profile" : "empty"} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger data-testid={testid} aria-label="Apertura Compila Orari"><SelectValue /></SelectTrigger>
        <SelectContent>
          {TIMESHEET_PREFILL_OPTIONS.map((o) => <SelectItem key={o.value} value={o.value} data-testid={`${testid}-option-${o.value}`}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
      <div className="text-[11px] text-suite-neutral-500 mt-1">Vale per tutta l&apos;azienda. Senza orari previsti nel profilo i campi restano vuoti.</div>
    </div>
  );
}

export default TimesheetPrefillSelect;
